/* src/app/core/modules/shared/components/progress-loader/progress-loader.component.scss */
.progress-circle-container {
  position: relative;
}
.progress-circle-container .circle-checkmark {
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);
}
/*# sourceMappingURL=/avvera/dev/progress-loader.component.css.map */
